"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABELSTATES = void 0;
const LABELSTATES = {
    INCOMPLETE: 'incomplete',
    COMPLETE: 'complete',
    VERIFIED: 'verified',
    EXPORTED: 'exported',
};
exports.LABELSTATES = LABELSTATES;
